import { Route } from "react-router-dom";
import React, { Component, useEffect } from "react";
import { useNeoAuth0 } from "./useNeoAuth0";
import { useLocation } from 'react-router-dom';

export const NeoProtectedRoute = ({ component: Component, ...rest }) => {
  const {
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    getIdTokenClaims
  } = useNeoAuth0();


  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      getIdTokenClaims().then(c => {
        if (c?.__raw) {
          localStorage.setItem("neo_id_token", c.__raw);
        }
      });
    }
  }, [isLoading, isAuthenticated]);

  const location = useLocation();
  const pathAndQuery = location.pathname + location.search;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isLoading) return null;

        if (!isAuthenticated) {
          loginWithRedirect({
            authorizationParams: {
              redirect_uri: window.location.origin + "/neocuesheet"
            },
            appState: { returnTo: pathAndQuery },
          });
          return null;
        }

        return <Component {...props} />;
      }}
    />
  );
};
